import { _Componentes_WebApiCalls_Post } from "../ComponentesGlobales/WebApiCalls";

const numero = (valor, alternativa = 0) => {
  const resultado = Number(valor);
  return Number.isFinite(resultado) ? resultado : alternativa;
};

export const normalizarCategoriaFiscal = (categoria = {}) => ({
  Id: numero(categoria.Id ?? categoria.CategoriaFiscalId),
  Codigo: String(categoria.Codigo ?? categoria.sCodigo ?? "").trim(),
  Descripcion: String(categoria.Descripcion ?? categoria.sDescripcion ?? "").trim(),
  PorcentajeIVA: numero(categoria.PorcentajeIVA ?? categoria.PorcentajeIva),
  ConSinIVA: categoria.ConSinIVA === undefined
    ? numero(categoria.PorcentajeIVA ?? categoria.PorcentajeIva) > 0
    : Boolean(categoria.ConSinIVA),
  Version: numero(categoria.Version, 1),
  VigenteDesde: String(categoria.VigenteDesde ?? ""),
  Predeterminada: categoria.Predeterminada === true,
  Activa: categoria.Activa !== false,
});

export const esCategoriaFiscalValida = (categoria) =>
  Number(categoria?.Id) > 0 &&
  Number(categoria?.Version) > 0 &&
  Number.isFinite(Number(categoria?.PorcentajeIVA)) &&
  Number(categoria.PorcentajeIVA) >= 0 &&
  Number(categoria.PorcentajeIVA) <= 100;

export const seleccionarCategoriaFiscalPredeterminada = (categorias = []) => {
  const validas = categorias.filter(esCategoriaFiscalValida);
  return validas.find((categoria) => categoria.Predeterminada)
    || validas.find((categoria) => Number(categoria.PorcentajeIVA) === 21)
    || null;
};

export const formatearCategoriaFiscal = (categoria) => {
  if (!categoria) return "";
  const descripcion = String(categoria.Descripcion || "").trim();
  if (/\biva\b.*%/i.test(descripcion)) return descripcion;

  const tasa = new Intl.NumberFormat("es-AR", { maximumFractionDigits: 2 })
    .format(Number(categoria.PorcentajeIVA) || 0);
  return descripcion ? `${descripcion} · IVA ${tasa} %` : `IVA ${tasa} %`;
};

export const calcularNetoDesdePrecioFinal = (precioFinal, categoria) => {
  const final = Math.max(0, numero(precioFinal));
  if (!categoria?.ConSinIVA) return final;
  return final / (1 + numero(categoria.PorcentajeIVA) / 100);
};

export async function listarCategoriasFiscales({ EmpresaId, signal } = {}) {
  const resultado = await _Componentes_WebApiCalls_Post(
    "Combos/CategoriasFiscales",
    { EmpresaId: Number(EmpresaId) || 0 },
    { signal },
  );
  if (resultado.aborted || resultado.error) return resultado;
  const origen = Array.isArray(resultado.data?.Lista) ? resultado.data.Lista : [];
  const Lista = origen
    .map(normalizarCategoriaFiscal)
    .filter((categoria) => categoria.Activa && esCategoriaFiscalValida(categoria));
  return { data: { ...resultado.data, Lista } };
}
